<script>
export default {
  name: 'IconChartNewUx',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6299 22.75H3.62988C3.21988 22.75 2.87988 22.41 2.87988 22C2.87988 21.59 3.21988 21.25 3.62988 21.25H21.6299C22.0399 21.25 22.3799 21.59 22.3799 22C22.3799 22.41 22.0399 22.75 21.6299 22.75Z"
      :fill="color"
    />
    <path
      d="M6.22988 8.37988H4.62988C4.07988 8.37988 3.62988 8.82988 3.62988 9.37988V17.9999C3.62988 18.5499 4.07988 18.9999 4.62988 18.9999H6.22988C6.77988 18.9999 7.22988 18.5499 7.22988 17.9999V9.37988C7.22988 8.81988 6.77988 8.37988 6.22988 8.37988Z"
      :fill="color"
    />
    <path
      d="M13.4298 5.18994H11.8298C11.2798 5.18994 10.8298 5.63994 10.8298 6.18994V17.9999C10.8298 18.5499 11.2798 18.9999 11.8298 18.9999H13.4298C13.9798 18.9999 14.4298 18.5499 14.4298 17.9999V6.18994C14.4298 5.63994 13.9798 5.18994 13.4298 5.18994Z"
      :fill="color"
    />
    <path
      d="M20.6298 2H19.0298C18.4798 2 18.0298 2.45 18.0298 3V18C18.0298 18.55 18.4798 19 19.0298 19H20.6298C21.1798 19 21.6298 18.55 21.6298 18V3C21.6298 2.45 21.1798 2 20.6298 2Z"
      :fill="color"
    />
  </svg>
</template>
